/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExpressionTypeFromJSON, ExpressionTypeToJSON } from './';
export function CheckExpressionRequestFromJSON(json) {
    return CheckExpressionRequestFromJSONTyped(json, false);
}
export function CheckExpressionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        expression: json['expression'],
        type: ExpressionTypeFromJSON(json['type']),
    };
}
export function CheckExpressionRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        expression: value.expression,
        type: ExpressionTypeToJSON(value.type),
    };
}
